import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/image/61222f31497f2.png';
import _imports_1 from '../assets/image/emoj.png';
import _imports_2 from '../assets/image/fanhui.png';
const _withScopeId = n => (_pushScopeId("data-v-6c366660"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_comment"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " 最新平论 ", -1));
const _hoisted_3 = {
  class: "conten"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "img"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "info"
};
const _hoisted_8 = {
  class: "name"
};
const _hoisted_9 = {
  class: "cont"
};
const _hoisted_10 = {
  class: "tiem"
};
const _hoisted_11 = {
  class: "comments"
};
const _hoisted_12 = {
  class: "imgs"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "infos"
};
const _hoisted_15 = {
  class: "name"
};
const _hoisted_16 = {
  class: "cont"
};
const _hoisted_17 = {
  class: "tiem"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "zan",
  style: {
    "color": "#007539"
  }
}, "回复", -1));
const _hoisted_19 = {
  key: 0,
  class: "zanwu"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无评论", -1));
const _hoisted_22 = [_hoisted_20, _hoisted_21];
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "70px"
  }
}, null, -1));
const _hoisted_24 = {
  class: "comment_input"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "说点好听的~", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_27 = [_hoisted_25, _hoisted_26];
const _hoisted_28 = {
  key: 0,
  class: "comment_f"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "fanhui",
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "14px",
    "color": "#fff"
  }
}, "返回", -1));
const _hoisted_31 = [_hoisted_29, _hoisted_30];
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, " 发表评论 ", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, null, -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "46px"
  }
}, null, -1));
const _hoisted_35 = {
  class: "cont"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "评论内容", -1));
const _hoisted_37 = {
  style: {
    "margin": "16px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "space-between"
  }
};
import { quick_comment } from '@/util/http';

import { ref, reactive } from 'vue';
export default {
  __name: 'comment',
  props: {
    commentList: {
      type: Array,
      default: []
    },
    activeIndexs: {
      type: Boolean,
      default: false
    }
  },
  emits: ['submit', 'commentNext', 'opencomment', 'returnUp'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    let activeIndex = ref(false);
    let data = reactive({
      content: '',
      level_uid: '',
      level_id: '',
      opencommentshow: false
    });

    // watch(props,(value,oldvalue)=>{
    //    console.log(value.activeIndexs)
    //    activeIndex.value = value.activeIndexs;

    //    console.log(activeIndex.value)
    // },{deep:true})
    const returnUp = () => {
      data.opencommentshow = !data.opencommentshow;
    };
    let opencomment = () => {
      data.level_uid = '';
      data.level_id = '';
      data.content = '';
      // emits('opencomment')
      data.opencommentshow = !data.opencommentshow;
    };
    let onSubmit = () => {
      data.opencommentshow = !data.opencommentshow;
      emits('submit', data);
    };
    let commentNext = item => {
      data.level_uid = item.uid;
      data.level_id = item.id;
      data.content = '';
      emits('commentNext');
    };
    let kj_comment = () => {
      let num = Math.floor(Math.random() * kj.value.length);
      data.content = kj.value[num];
    };
    let kj = ref([]);
    quick_comment().then(res => {
      kj.value = res.data;
    });
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.commentList, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: "item",
          key: index,
          onClick: $event => _unref(commentNext)(item)
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          src: item.user.avatar,
          alt: ""
        }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(item.user.nickname), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(item.content), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(item.create_time), 1), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.comments, (items, indexs) => {
          return _openBlock(), _createElementBlock("li", {
            class: "",
            key: indexs
          }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
            src: items.user.avatar,
            alt: ""
          }, null, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(items.user.nickname), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(items.content), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(items.create_time), 1)])]);
        }), 128))])]), _hoisted_18], 8, _hoisted_4);
      }), 128)), __props.commentList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22)) : _createCommentVNode("", true)])])]), _hoisted_23, _createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
        class: "conmment_info",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(opencomment) && _unref(opencomment)(...args))
      }, _hoisted_27)]), _unref(data).opencommentshow ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", {
        class: "header"
      }, [_createElementVNode("div", {
        class: "icon"
      }, [_createElementVNode("div", {
        class: "left",
        onClick: returnUp
      }, _hoisted_31)]), _hoisted_32, _hoisted_33]), _hoisted_34, _createElementVNode("div", _hoisted_35, [_hoisted_36, _createVNode(_component_van_form, {
        onSubmit: _unref(onSubmit)
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell_group, {
          inset: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            modelValue: _unref(data).content,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(data).content = $event),
            rows: "6",
            autosize: "",
            type: "textarea",
            maxlength: "500",
            placeholder: "请输入留言",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_37, [_createVNode(_component_van_button, {
          style: {
            "width": "70%"
          },
          round: "",
          block: "",
          type: "primary",
          color: "#007539",
          "native-type": "submit"
        }, {
          default: _withCtx(() => [_createTextVNode(" 发布 ")]),
          _: 1
        }), _createVNode(_component_van_button, {
          round: "",
          color: "#007539",
          type: "primary",
          onClick: _unref(kj_comment)
        }, {
          default: _withCtx(() => [_createTextVNode("快捷评论")]),
          _: 1
        }, 8, ["onClick"])])]),
        _: 1
      }, 8, ["onSubmit"])])])) : _createCommentVNode("", true)], 64);
    };
  }
};